import React, { useState } from 'react';
import axios from 'axios';
import { FaEdit, FaCheck, FaTimes } from 'react-icons/fa';
import { toast } from 'react-toastify';

const MatchPlayerCoinsEditor = ({ player, matchId, refreshData }) => {
  const [editing, setEditing] = useState(false);
  const [tempCoins, setTempCoins] = useState(player.match_coins_won || '');

  const updateCoins = async () => {
    if (!tempCoins || isNaN(tempCoins)) {
      toast.error('Enter a valid coin value');
      return;
    }

    try {
      const token = localStorage.getItem('token');
      await axios.post(
        'https://backend.aubattle.com/api/coins/update-match-player-coins',
        {
          email: player.email,
          coinsWon: Number(tempCoins),
          matchId,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success('Coins updated successfully!');
      setEditing(false);
      refreshData(); // refetch matches
    } catch (error) {
      toast.error('Failed to update coins');
      console.error('Update error:', error);
    }
  };

  return (
    <div className="coins-control">
      {editing ? (
        <>
          <input
            type="number"
            value={tempCoins}
            onChange={(e) => setTempCoins(e.target.value)}
            className="coin-input"
            placeholder="Coins"
          />
          <button className="btn-icon confirm" onClick={updateCoins}>
            <FaCheck />
          </button>
          <button className="btn-icon cancel" onClick={() => setEditing(false)}>
            <FaTimes />
          </button>
        </>
      ) : (
        <>
          <span>Coins: {player.match_coins_won || 0}</span>
          <button className="btn-icon edit" onClick={() => setEditing(true)}>
            <FaEdit />
          </button>
        </>
      )}
    </div>
  );
};

export default MatchPlayerCoinsEditor;
